import * as React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

export default function PageBar({ size, count, pageNo, onChangePage }) {
  return (
    <Stack spacing={2}>
      <Pagination
        count={count}
        size={size || "small"}
        page={pageNo || 1}
        onChange={(val, val2) => onChangePage(val2)}
      />
    </Stack>
  );
}
